import { Award, Users, Shield, MapPin } from "lucide-react";

const ITEMS = [
  { icon: Award, title: "40+ años", subtitle: "de experiencia" },
  { icon: Users, title: "+15.000", subtitle: "pacientes atendidos" },
  { icon: Shield, title: "Financiación", subtitle: "a tu medida" },
  { icon: MapPin, title: "Junto a la playa", subtitle: "y estación Renfe" },
];

export default function TrustBar() {
  return (
    <section className="py-10 bg-white border-y border-slate-100" data-testid="trust-bar">
      <div className="container-max">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-4">
          {ITEMS.map((it, i) => (
            <div key={i} className="flex items-center gap-4" data-testid={`trust-item-${i}`}>
              <div className="w-12 h-12 rounded-full bg-teal-50 flex items-center justify-center shrink-0">
                <it.icon className="w-5 h-5 text-teal-700" />
              </div>
              <div>
                <div className="font-bold text-slate-900 text-base leading-tight">{it.title}</div>
                <div className="text-xs text-slate-500">{it.subtitle}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
